module.exports = __webpack_public_path__ + "img/__icon_BDE.d43e3cce.svg";